import { useOpenSupportChat } from "@/helpers/useOpenSupportChat";
import { Chat } from "@mui/icons-material";
import {
  IconButton,
  NoSsr,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { important } from "@nvon/react-toolbox";

/**
 * Placeholder, showing until:
 *  - the user has accepted the cookies to show our chat widet
 *  - and the chat widget is fully loaded
 */
export const SLChatButtonPlaceholder = (): React.JSX.Element | null => {
  return (
    <NoSsr>
      <Inner />
    </NoSsr>
  );
};

const Inner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const { openChat } = useOpenSupportChat();
  if (isMobile) {
    return null;
  }

  return (
    <Tooltip title="Chat starten" placement="left">
      <IconButton
        onClick={() => openChat()}
        aria-label="Start live chat support"
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.success.light,
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
          boxShadow: important(2),
          position: "fixed",
          zIndex: 10000,
          bottom: theme.spacing(isMobile ? 2 : 4),
          right: theme.spacing(isMobile ? 2 : 4),
        }}
        size={isMobile ? "small" : "large"}
      >
        <Chat />
      </IconButton>
    </Tooltip>
  );
};
